const utilities = {
  /**
   * Open new dialog
   * @param uri
   * @param name
   * @param options
   * @param closeCallback
   * @returns {Window}
   */
  openDialog(uri, name, options, closeCallback) {
    const win = window.open(uri, name, options);
    const interval = window.setInterval(() => {
      try {
        if (win == null || win.closed) {
          window.clearInterval(interval);
          closeCallback(win);
        }
      } catch (e) {
        console.warn('error into openDialog', e);
      }
    }, 1000);

    return win;
  },
};

const Utils = {};

Utils.install = (Vue) => {
  Vue.prototype.$utils = utilities;
};

export default Utils;



// WEBPACK FOOTER //
// ./src/plugins/vue-utils.js